import { Space, Avatar, Button } from "antd";
import { UserOutlined } from '@ant-design/icons';
import styled from '@xstyled/styled-components';
import React from 'react';
import { SuccessButton } from "..";

const AvatarIcon = styled(UserOutlined)`
    font-size: 32px;
`;

const UserRequest: React.SFC = () => {
    return <div className="py-2">
        <Space align="center" direction="horizontal">
            <Avatar className="cursor-pointer" size={"large"} icon={<AvatarIcon />} />
            <div className="inline-block pr-4">
                <span className="font-bold w-full block pb-0">John doe</span>
                <span>He knows you</span>
            </div>
            <Space align="center">
                <SuccessButton className="rounded-md" type="primary">Accept</SuccessButton>
                <Button className="rounded-md">Cancel</Button>
            </Space>
        </Space>
    </div>
}

export default UserRequest;

